import { gql } from '@apollo/client';

export const UPSERT_INTERVENTION_PEOPLE_PROFILES_MANAGER = gql`
  mutation UpsertInterventionPeopleProfile($input: UpsertInterventionPeopleProfilesInput!) {
    interventionPeopleProfile: upsertInterventionPeopleProfile(input: $input) {
      id
    }
  }
`;
